<div class="flex" [class]="data.type">
  <div class="mr-2 size-6 flex-none">
    <mat-icon [color]="color()">{{ icon() }}</mat-icon>
  </div>
  <div class="flex flex-col gap-2">
    <p class="m-0!">{{ data.title | transloco }}</p>
    @if (data.message) {
      <div class="m-0!">{{ data.message | transloco }}</div>
    }
    @if (data.details?.length) {
      @for (detail of data.details; track detail) {
        <div class="m-0! text-sm">{{ detail | transloco }}</div>
      }
    }
  </div>
</div>
